export const getPoiIcon = (poi) => {
	var key = poi.type
	if (!osm_icons[key]) key = poi.type.split(':')[0]
	if (osm_icons[key]) return osm_icons[key]
	return {
		name: key,
		img: '9/97/Place-6.svg',
	}
}

export const getPoiName = (poi) => {
	if (poi.name) return poi.name
	return getPoiIcon(poi).name
}

export const getPoiDescription = (poi) => {
	const icon = getPoiIcon(poi)
	if (icon.name) return icon.name
	return poi.type.split(':')[1]
}

export const getPoiIconUrl = (poi) => {
	const iconUrl = getPoiIcon(poi).img
	if (iconUrl.indexOf('data:image') > -1) return iconUrl
	return 'https://wiki.openstreetmap.org/w/images/' + iconUrl
}

export const osm_icons = {
	'place:other': {
		name: 'Annet',
		category: 'place',
		tag: 'other',
		img: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath d='M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'/%3E%3C/svg%3E",
	},
	'place:home': {
		name: 'Hjemmeadresse',
		category: 'place',
		tag: 'home',
		img: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'%3E%3C!--! --%3E%3Cpath d='M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472a40 40 0 0 1-40 40h-16l-3.3-.1-4.2.1H392a40 40 0 0 1-40-40v-88a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32v88a40 40 0 0 1-40 40h-55.9l-4.5-.2-3.6.2h-16a40 40 0 0 1-40-40V360l.1-2.8v-69.6H32c-18 0-32-14-32-32.1 0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7l255.4 224.5c8 7 12 15 11 24z'/%3E%3C/svg%3E",
	},
	'place:work': {
		name: 'Arbeidsplass',
		category: 'place',
		tag: 'work',
		img: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3C!--! --%3E%3Cpath d='M48 0A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h96v-80a48 48 0 0 1 96 0v80h96a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48H48zm16 240a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-32zm112-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16zm80 16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32zM80 96h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16zm80 16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32zm112-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16z'/%3E%3C/svg%3E",
	},
	pt: {
		name: 'Stoppsted',
		category: 'transport',
		tag: 'stoppested',
		img: '5/52/Bus-stop-12.svg',
	},
	'building:school': {
		name: 'Skolebygning',
		category: 'school',
		tag: 'building',
		img: '/b/b2/Amenity_school_humanitarian.svg',
	},
	'building:hotel': {
		name: 'Hotelbygning',
		category: 'hotel',
		tag: 'building',
		img: 'c/ca/Hotel-16.svg',
	},
	'building:office': {
		name: 'Kontorbygning',
		category: 'building',
		tag: 'building',
		img: '9/97/Place-6.svg',
	},
	'building:retail': {
		name: 'Butikk',
		category: 'building',
		tag: 'building',
		img: 'c/c4/Shop-other-16.svg',
	},
	'amenity:restaurant': {
		name: 'Restaurant',
		category: 'amenity',
		tag: 'restaurant',
		img: 'b/bb/Restaurant-14.svg',
	},
	'amenity:food_court': {
		name: 'Mat hall',
		category: 'amenity',
		tag: 'food_court',
		img: 'b/bb/Restaurant-14.svg',
	},
	'amenity:cafe': {
		name: 'Kafè',
		category: 'amenity',
		tag: 'cafe',
		img: 'd/da/Cafe-16.svg',
	},
	'amenity:fast_food': {
		name: 'Hurtigmat',
		category: 'amenity',
		tag: 'fast_food',
		img: '1/1f/Fast-food-16.svg',
	},
	'amenity:bar': {
		name: 'Bar',
		category: 'amenity',
		tag: 'bar',
		img: '9/94/Bar-16.svg',
	},
	'amenity:pub': {
		name: 'Pub',
		category: 'amenity',
		tag: 'pub',
		img: '5/5d/Pub-16.svg',
	},
	'amenity:ice_cream': {
		name: 'Iskrem',
		category: 'amenity',
		tag: 'ice_cream',
		img: '0/0f/Ice-cream-14.svg',
	},
	'amenity:biergarten': {
		name: 'Ølhage',
		category: 'amenity',
		tag: 'biergarten',
		img: 'e/e1/Biergarten-16.svg',
	},
	'leisure:outdoor_seating': {
		name: 'Outdoor Seating',
		category: 'leisure',
		tag: 'outdoor_seating',
		img: 'a/ac/Outdoor_seating-14.svg',
	},
	'tourism:artwork': {
		name: 'Kunst',
		category: 'tourism',
		tag: 'artwork',
		img: '9/9f/Bust-14.svg',
	},
	'amenity:community_centre': {
		name: 'Community Centre',
		category: 'amenity',
		tag: 'community_centre',
		img: '0/0b/Community_centre-14.svg',
	},
	'amenity:library': {
		name: 'Bibliotek',
		category: 'amenity',
		tag: 'library',
		img: 'c/c5/Library.14.svg',
	},
	'tourism:museum': {
		name: 'Museum',
		category: 'tourism',
		tag: 'museum',
		img: 'a/a9/Museum-16.svg',
	},
	'amenity:theatre': {
		name: 'Teater',
		category: 'amenity',
		tag: 'theatre',
		img: 'e/eb/Theatre-16.svg',
	},
	'amenity:cinema': {
		name: 'Kino',
		category: 'amenity',
		tag: 'cinema',
		img: '3/31/Cinema-16.svg',
	},
	'amenity:nightclub': {
		name: 'Nattklubb',
		category: 'amenity',
		tag: 'nightclub',
		img: 'e/ee/Nightclub-16.svg',
	},
	'amenity:arts_centre': {
		name: 'Kunstsenter',
		category: 'amenity',
		tag: 'arts_centre',
		img: 'b/bf/Arts_centre.svg',
	},
	'tourism:gallery': {
		name: 'Galleri',
		category: 'tourism',
		tag: 'gallery',
		img: '7/7e/Gallery-14.svg',
	},
	'amenity:internet_cafe': {
		name: 'Internet Cafe',
		category: 'amenity',
		tag: 'internet_cafe',
		img: '8/89/Internet_cafe-14.svg',
	},
	'amenity:casino': {
		name: 'Kasino',
		category: 'amenity',
		tag: 'casino',
		img: '8/83/Casino-14.svg',
	},
	'amenity:public_bookcase': {
		name: 'Offentlig bokhylle',
		category: 'amenity',
		tag: 'public_bookcase',
		img: 'b/b2/Public_bookcase-14.svg',
	},
	'leisure:amusement_arcade': {
		name: 'Amusement Arcade',
		category: 'leisure',
		tag: 'amusement_arcade',
		img: '4/44/Amusement_arcade-14.svg',
	},
	'historic:memorial': {
		name: 'Minnesmerke',
		category: 'historic',
		tag: 'memorial',
		img: '9/9f/Bust-14.svg',
	},
	'historic:archaeological_site': {
		name: 'Arkeologisk funnsted',
		category: 'historic',
		tag: 'archaeological_site',
		img: '7/7d/Archaeological-site-16.svg',
	},
	'historic:wayside_shrine': {
		name: 'Helligdom langs veien',
		category: 'historic',
		tag: 'wayside_shrine',
		img: '1/17/Carto_shrine.svg',
	},
	'historic:monument': {
		name: 'Monument',
		category: 'historic',
		tag: 'monument',
		img: '9/94/Monument-16.svg',
	},
	'historic:castle': {
		name: 'Borg',
		category: 'historic',
		tag: 'castle',
		img: '4/41/Manor-14.svg',
	},
	'historic:fort': {
		name: 'Fort',
		category: 'historic',
		tag: 'fort',
		img: '0/0d/Historic-fort.svg',
	},
	'historic:city_gate': {
		name: 'Byport',
		category: 'historic',
		tag: 'city_gate',
		img: '4/47/City-gate-14.svg',
	},
	'historic:manor': {
		name: 'Herregård',
		category: 'historic',
		tag: 'manor',
		img: '4/41/Manor-14.svg',
	},
	'man_made:obelisk': {
		name: 'Obelisk',
		category: 'man_made',
		tag: 'obelisk',
		img: '8/82/Obelisk-14.svg',
	},
	'leisure:playground': {
		name: 'Lekeplass',
		category: 'leisure',
		tag: 'playground',
		img: '3/31/Playground-16.svg',
	},
	'leisure:fitness_centre': {
		name: 'Treningssenter',
		category: 'leisure',
		tag: 'fitness_centre',
		img: 'b/bd/Fitness.svg',
	},
	'leisure:fitness_station': {
		name: 'Treningsstasjon',
		category: 'leisure',
		tag: 'fitness_station',
		img: 'b/bd/Fitness.svg',
	},
	'leisure:golf_course': {
		name: 'Golfbane',
		category: 'leisure',
		tag: 'golf_course',
		img: 'd/d2/Golf-icon.svg',
	},
	'leisure:water_park': {
		name: 'Vann park',
		category: 'leisure',
		tag: 'water_park',
		img: 'c/cb/Swimming-16.svg',
	},
	'leisure:swimming_area': {
		name: 'Badeplass',
		category: 'leisure',
		tag: 'swimming_area',
		img: 'c/cb/Swimming-16.svg',
	},
	'leisure:sports_centre': {
		name: 'Sportssenter',
		category: 'leisure',
		tag: 'sports_centre',
		img: 'c/cb/Swimming-16.svg',
	},
	'shop:massage': {
		name: 'Massasje',
		category: 'shop',
		tag: 'massage',
		img: '2/29/Massage-14.svg',
	},
	'leisure:sauna': {
		name: 'Badstue',
		category: 'leisure',
		tag: 'sauna',
		img: '3/3a/Sauna-14.svg',
	},
	'amenity:public_bath': {
		name: 'Offentlig bad',
		category: 'amenity',
		tag: 'public_bath',
		img: '0/01/Public_bath.svg',
	},
	'leisure:miniature_golf': {
		name: 'Minigolf',
		category: 'leisure',
		tag: 'miniature_golf',
		img: '4/44/Miniature_golf.svg',
	},
	'leisure:beach_resort': {
		name: 'Beach Resort',
		category: 'leisure',
		tag: 'beach_resort',
		img: 'c/cd/Beach_resort-14.svg',
	},
	'leisure:fishing': {
		name: 'Fishing',
		category: 'leisure',
		tag: 'fishing',
		img: 'b/ba/Fishing-14.svg',
	},
	'leisure:bowling_alley': {
		name: 'Bowling Alley',
		category: 'leisure',
		tag: 'bowling_alley',
		img: '0/05/Bowling_alley-14.svg',
	},
	'leisure:dog_park': {
		name: 'Dog Park',
		category: 'leisure',
		tag: 'dog_park',
		img: 'd/da/Dog_park.svg',
	},
	'golf:pin': {
		name: 'Pin',
		category: 'golf',
		tag: 'pin',
		img: 'c/ca/Leisure-golf-pin.svg',
	},
	'amenity:toilets': {
		name: 'Toaletter',
		category: 'amenity',
		tag: 'toilets',
		img: 'f/fa/Toilets-16.svg',
	},
	'amenity:recycling': {
		name: 'Gjenvinning',
		category: 'amenity',
		tag: 'recycling',
		img: '1/16/Recycling-16.svg',
	},
	'amenity:waste_basket': {
		name: 'Waste Basket',
		category: 'amenity',
		tag: 'waste_basket',
		img: '6/6f/Waste-basket-12.svg',
	},
	'amenity:waste_disposal': {
		name: 'Waste Disposal',
		category: 'amenity',
		tag: 'waste_disposal',
		img: 'e/e6/Waste_disposal-14.svg',
	},
	'amenity:vending_machine': {
		name: 'Vending Machine',
		category: 'amenity',
		tag: 'vending_machine',
		img: '2/28/Public_transport_tickets-14.svg',
	},
	'amenity:bench': {
		name: 'Bench',
		category: 'amenity',
		tag: 'bench',
		img: '0/0c/Bench-16.svg',
	},
	'amenity:shelter': {
		name: 'Skjul',
		category: 'amenity',
		tag: 'shelter',
		img: 'f/f8/Shelter-14.svg',
	},
	'amenity:drinking_water': {
		name: 'Drikkevann',
		category: 'amenity',
		tag: 'drinking_water',
		img: '0/08/Drinking-water-16.svg',
	},
	'tourism:picnic_site': {
		name: 'Picnic Site',
		category: 'tourism',
		tag: 'picnic_site',
		img: 'f/fc/Picnic_site.svg',
	},
	'amenity:fountain': {
		name: 'Fountain',
		category: 'amenity',
		tag: 'fountain',
		img: 'a/a1/Fountain-14.svg',
	},
	'tourism:camp_site': {
		name: 'Camp Site',
		category: 'tourism',
		tag: 'camp_site',
		img: 'e/e4/Camping.16.svg',
	},
	'leisure:picnic_table': {
		name: 'Picnic Table',
		category: 'leisure',
		tag: 'picnic_table',
		img: '7/7d/Table-16.svg',
	},
	'tourism:caravan_site': {
		name: 'Caravan Site',
		category: 'tourism',
		tag: 'caravan_site',
		img: 'a/a1/Caravan-16.svg',
	},
	'amenity:bbq': {
		name: 'Bbq',
		category: 'amenity',
		tag: 'bbq',
		img: '5/50/Bbq-14.svg',
	},
	'amenity:shower': {
		name: 'Shower',
		category: 'amenity',
		tag: 'shower',
		img: '5/5a/Shower-14.svg',
	},
	'leisure:firepit': {
		name: 'Firepit',
		category: 'leisure',
		tag: 'firepit',
		img: 'd/df/Firepit.svg',
	},
	'leisure:bird_hide': {
		name: 'Bird Hide',
		category: 'leisure',
		tag: 'bird_hide',
		img: '9/92/Bird_hide-14.svg',
	},
	'tourism:information': {
		name: 'Information',
		category: 'tourism',
		tag: 'information',
		img: '6/6a/Audioguide-14.svg',
	},
	'tourism:viewpoint': {
		name: 'Viewpoint',
		category: 'tourism',
		tag: 'viewpoint',
		img: 'c/c2/Viewpoint-16.svg',
	},
	'tourism:hotel': {
		name: 'Hotel',
		category: 'tourism',
		tag: 'hotel',
		img: 'c/ca/Hotel-16.svg',
	},
	'tourism:guest_house': {
		name: 'Guest House',
		category: 'tourism',
		tag: 'guest_house',
		img: 'd/dc/Tourism_guest_house.svg',
	},
	'tourism:hostel': {
		name: 'Hostel',
		category: 'tourism',
		tag: 'hostel',
		img: '4/4f/Hostel-16.svg',
	},
	'tourism:chalet': {
		name: 'Chalet',
		category: 'tourism',
		tag: 'chalet',
		img: 'e/e9/Chalet.svg',
	},
	'tourism:motel': {
		name: 'Motel',
		category: 'tourism',
		tag: 'motel',
		img: '1/10/Motel-16.svg',
	},
	'tourism:apartment': {
		name: 'Apartment',
		category: 'tourism',
		tag: 'apartment',
		img: '0/0d/Apartment.svg',
	},
	'tourism:alpine_hut': {
		name: 'Alpine Hut',
		category: 'tourism',
		tag: 'alpine_hut',
		img: 'f/f1/Alpinehut.svg',
	},
	'tourism:wilderness_hut': {
		name: 'Wilderness Hut',
		category: 'tourism',
		tag: 'wilderness_hut',
		img: '8/8e/Wilderness_hut.svg',
	},
	'amenity:bank': {
		name: 'Bank',
		category: 'amenity',
		tag: 'bank',
		img: '3/3b/Bank-16.svg',
	},
	'amenity:atm': {
		name: 'Minibank',
		category: 'amenity',
		tag: 'atm',
		img: 'f/f9/Atm-14.svg',
	},
	'amenity:bureau_de_change': {
		name: 'Vekslingskontor',
		category: 'amenity',
		tag: 'bureau_de_change',
		img: 'e/ed/Bureau_de_change-14.svg',
	},
	'amenity:pharmacy': {
		name: 'Apotek',
		category: 'amenity',
		tag: 'pharmacy',
		img: '1/1e/Pharmacy-14.svg',
	},
	'amenity:hospital': {
		name: 'Sykehus',
		category: 'amenity',
		tag: 'hospital',
		img: '3/33/Hospital-14.svg',
	},
	'amenity:clinic': {
		name: 'Clinic',
		category: 'amenity',
		tag: 'clinic',
		img: '7/71/Doctors-14.svg',
	},
	'amenity:doctors': {
		name: 'Legesenter',
		category: 'amenity',
		tag: 'doctors',
		img: '7/71/Doctors-14.svg',
	},
	'amenity:dentist': {
		name: 'Tannlege',
		category: 'amenity',
		tag: 'dentist',
		img: '8/86/Dentist-14.svg',
	},
	'amenity:veterinary': {
		name: 'Veterinær',
		category: 'amenity',
		tag: 'veterinary',
		img: 'f/fc/Veterinary-14.svg',
	},
	'amenity:post_box': {
		name: 'Post Box',
		category: 'amenity',
		tag: 'post_box',
		img: 'd/d4/Post_box-12.svg',
	},
	'amenity:post_office': {
		name: 'Postkontor',
		category: 'amenity',
		tag: 'post_office',
		img: 'e/e1/Post_office-14.svg',
	},
	'amenity:parcel_locker': {
		name: 'Parcel Locker',
		category: 'amenity',
		tag: 'parcel_locker',
		img: 'b/b5/Parcel_locker.svg',
	},
	'amenity:telephone': {
		name: 'Telephone',
		category: 'amenity',
		tag: 'telephone',
		img: 'f/fa/Telephone.16.svg',
	},
	'emergency:phone': {
		name: 'Phone',
		category: 'emergency',
		tag: 'phone',
		img: '1/1c/Emergency-phone.16.svg',
	},
	'amenity:parking': {
		name: 'Parkering',
		category: 'amenity',
		tag: 'parking',
		img: '6/64/Parking-subtle.svg',
	},
	'highway:bus_stop': {
		name: 'Bus Stop',
		category: 'highway',
		tag: 'bus_stop',
		img: '5/52/Bus-stop-12.svg',
	},
	'amenity:fuel': {
		name: 'Bensinstasjon',
		category: 'amenity',
		tag: 'fuel',
		img: '7/77/Fuel-16.svg',
	},
	'amenity:bicycle_parking': {
		name: 'Sykkeparkering',
		category: 'amenity',
		tag: 'bicycle_parking',
		img: '7/7f/Parking-bicycle-16.svg',
	},
	'amenity:bus_station': {
		name: 'Busstasjon',
		category: 'amenity',
		tag: 'bus_station',
		img: '5/5a/Amenity_bus_station.svg',
	},
	'aeroway:helipad': {
		name: 'Helipad',
		category: 'aeroway',
		tag: 'helipad',
		img: 'e/ed/Helipad.16.svg',
	},
	'aeroway:aerodrome': {
		name: 'Aerodrome',
		category: 'aeroway',
		tag: 'aerodrome',
		img: 'b/bc/Aerodrome.svg',
	},
	'amenity:bicycle_rental': {
		name: 'Sykkelutleie',
		category: 'amenity',
		tag: 'bicycle_rental',
		img: 'd/d5/Rental-bicycle-16.svg',
	},
	'leisure:slipway': {
		name: 'Slipway',
		category: 'leisure',
		tag: 'slipway',
		img: '8/88/Transport_slipway.svg',
	},
	'amenity:taxi': {
		name: 'Taxi',
		category: 'amenity',
		tag: 'taxi',
		img: '9/94/Taxi.16.svg',
	},
	'railway:station': {
		name: 'Stasjon',
		category: 'railway',
		tag: 'railway_station',
		img: '3/3c/Subway-entrance-12.svg',
	},
	'railway:subway_entrance': {
		name: 'T-bane Inngang',
		category: 'railway',
		tag: 'subway_entrance',
		img: '3/3c/Subway-entrance-12.svg',
	},
	'amenity:charging_station': {
		name: 'Ladestasjon',
		category: 'amenity',
		tag: 'charging_station',
		img: 'a/af/Charging_station.16.svg',
	},
	'highway:elevator': {
		name: 'Elevator',
		category: 'highway',
		tag: 'elevator',
		img: '6/6d/Elevator-12.svg',
	},
	'amenity:car_rental': {
		name: 'Bilutleie',
		category: 'amenity',
		tag: 'car_rental',
		img: '1/11/Rental-car-16.svg',
	},
	'amenity:parking_entrance': {
		name: 'Parking Entrance',
		category: 'amenity',
		tag: 'parking_entrance',
		img: '8/86/Parking_entrance_multi-storey_14.svg',
	},
	'amenity:ferry_terminal': {
		name: 'Ferry Terminal',
		category: 'amenity',
		tag: 'ferry_terminal',
		img: '2/24/Ferry-icon.svg',
	},
	'amenity:motorcycle_parking': {
		name: 'Motorcycle Parking',
		category: 'amenity',
		tag: 'motorcycle_parking',
		img: '3/31/Parking-motorcycle-16.svg',
	},
	'amenity:bicycle_repair_station': {
		name: 'Bicycle Repair Station',
		category: 'amenity',
		tag: 'bicycle_repair_station',
		img: '0/01/Bicycle_repair_station-14.svg',
	},
	'amenity:boat_rental': {
		name: 'Boat Rental',
		category: 'amenity',
		tag: 'boat_rental',
		img: 'b/b1/Boat_rental-14.svg',
	},
	'oneway:yes': {
		name: 'Yes',
		category: 'oneway',
		tag: 'yes',
		img: 'e/e6/Oneway.svg',
	},
	'barrier:gate': {
		name: 'Gate',
		category: 'barrier',
		tag: 'gate',
		img: '9/97/Barrier_gate.svg',
	},
	'highway:traffic_signals': {
		name: 'Trafikklys',
		category: 'highway',
		tag: 'traffic_signals',
		img: '8/84/Traffic_light-16.svg',
	},
	'railway:level_crossing': {
		name: 'Jernebaneovergang',
		category: 'railway',
		tag: 'level_crossing',
		img: 'f/f7/Level_crossing.svg',
	},
	'railway:stop': {
		name: 'Togstasjon',
		category: 'railway',
		tag: 'crossing',
		img: '1/11/Rendering-railway-tram_stop-mapnik.png.png',
	},
	'railway:crossing': {
		name: 'Jernebaneovergang',
		category: 'railway',
		tag: 'crossing',
		img: 'f/f7/Level_crossing.svg',
	},
	'barrier:bollard': {
		name: 'Pullert',
		category: 'barrier',
		tag: 'bollard',
		img: '8/8f/Barrier.svg',
	},
	'barrier:block': {
		name: 'Block',
		category: 'barrier',
		tag: 'block',
		img: '8/8f/Barrier.svg',
	},
	'barrier:turnstile': {
		name: 'Turnstile',
		category: 'barrier',
		tag: 'turnstile',
		img: '8/8f/Barrier.svg',
	},
	'barrier:log': {
		name: 'Log',
		category: 'barrier',
		tag: 'log',
		img: '8/8f/Barrier.svg',
	},
	'barrier:lift_gate': {
		name: 'Lift Gate',
		category: 'barrier',
		tag: 'lift_gate',
		img: '8/8f/Liftgate-7.svg',
	},
	'barrier:swing_gate': {
		name: 'Swing Gate',
		category: 'barrier',
		tag: 'swing_gate',
		img: '8/8f/Liftgate-7.svg',
	},
	'barrier:cycle_barrier': {
		name: 'Cycle Barrier',
		category: 'barrier',
		tag: 'cycle_barrier',
		img: '0/09/Cycle_barrier-14.svg',
	},
	'barrier:stile': {
		name: 'Stile',
		category: 'barrier',
		tag: 'stile',
		img: '7/7c/Barrier_stile-14.svg',
	},
	'highway:mini_roundabout': {
		name: 'Mini Roundabout',
		category: 'highway',
		tag: 'mini_roundabout',
		img: '9/9b/Highway_mini_roundabout.svg',
	},
	'barrier:toll_booth': {
		name: 'Toll Booth',
		category: 'barrier',
		tag: 'toll_booth',
		img: 'd/d7/Toll_booth.svg',
	},
	'barrier:cattle_grid': {
		name: 'Cattle Grid',
		category: 'barrier',
		tag: 'cattle_grid',
		img: '4/4c/Barrier_cattle_grid-14.svg',
	},
	'barrier:kissing_gate': {
		name: 'Kissing Gate',
		category: 'barrier',
		tag: 'kissing_gate',
		img: '2/2f/Kissing_gate-14.svg',
	},
	'barrier:full-height_turnstile': {
		name: 'Full-Height Turnstile',
		category: 'barrier',
		tag: 'full-height_turnstile',
		img: 'b/bb/Full-height_turnstile-14.svg',
	},
	'barrier:motorcycle_barrier': {
		name: 'Motorcycle Barrier',
		category: 'barrier',
		tag: 'motorcycle_barrier',
		img: 'b/b5/Motorcycle_barrier-14.svg',
	},
	'ford:yes': {
		name: 'Yes',
		category: 'ford',
		tag: 'yes',
		img: '5/50/Ford.16.svg',
	},
	'ford:stepping_stones': {
		name: 'Stepping Stones',
		category: 'ford',
		tag: 'stepping_stones',
		img: '5/50/Ford.16.svg',
	},
	'mountain_pass:yes': {
		name: 'Yes',
		category: 'mountain_pass',
		tag: 'yes',
		img: 'a/a5/Mountain_pass-8.svg',
	},
	'waterway:dam': {
		name: 'Dam',
		category: 'waterway',
		tag: 'dam',
		img: 'c/cb/Dam_node.svg',
	},
	'waterway:weir': {
		name: 'Weir',
		category: 'waterway',
		tag: 'weir',
		img: '0/00/Weir_node.svg',
	},
	'waterway:lock_gate': {
		name: 'Lock Gate',
		category: 'waterway',
		tag: 'lock_gate',
		img: '9/97/Lock_gate_node.svg',
	},
	'highway:turning_circle': {
		name: 'Turning Circle',
		category: 'highway',
		tag: 'turning_circle',
		img: '2/2f/Turning_circle_on_highway_track-16.svg',
	},
	'highway:track': {
		name: 'Track',
		category: 'highway',
		tag: 'track',
		img: '2/2f/Turning_circle_on_highway_track-16.svg',
	},
	'natural:tree': {
		name: 'Tree',
		category: 'natural',
		tag: 'tree',
		img: '6/65/Tree-16.svg',
	},
	'natural:peak': {
		name: 'Peak',
		category: 'natural',
		tag: 'peak',
		img: '6/67/Peak-8.svg',
	},
	'natural:spring': {
		name: 'Spring',
		category: 'natural',
		tag: 'spring',
		img: '0/0e/Spring-14.svg',
	},
	'natural:cave_entrance': {
		name: 'Cave Entrance',
		category: 'natural',
		tag: 'cave_entrance',
		img: 'b/b1/Cave.14.svg',
	},
	'waterway:waterfall': {
		name: 'Waterfall',
		category: 'waterway',
		tag: 'waterfall',
		img: '7/72/Waterfall-14.svg',
	},
	'natural:saddle': {
		name: 'Saddle',
		category: 'natural',
		tag: 'saddle',
		img: 'a/a3/Saddle-8.svg',
	},
	'natural:volcano': {
		name: 'Volcano',
		category: 'natural',
		tag: 'volcano',
		img: 'e/e3/Volcano-8.svg',
	},
	'amenity:police': {
		name: 'Politi',
		category: 'amenity',
		tag: 'police',
		img: '5/59/Police-16.svg',
	},
	'amenity:townhall': {
		name: 'Townhall',
		category: 'amenity',
		tag: 'townhall',
		img: 'a/a3/Town-hall-16.svg',
	},
	'amenity:fire_station': {
		name: 'Brannstasjon',
		category: 'amenity',
		tag: 'fire_station',
		img: 'b/b7/Fire-station-16.svg',
	},
	'amenity:social_facility': {
		name: 'Social Facility',
		category: 'amenity',
		tag: 'social_facility',
		img: '0/0e/Social_facility-14.svg',
	},
	'amenity:courthouse': {
		name: 'Tinghus',
		category: 'amenity',
		tag: 'courthouse',
		img: 'd/db/Courthouse-16.svg',
	},
	'office:diplomatic': {
		name: 'Diplomatic',
		category: 'office',
		tag: 'diplomatic',
		img: '4/4f/Office-diplomatic-consulate.svg',
	},
	'amenity:prison': {
		name: 'Prison',
		category: 'amenity',
		tag: 'prison',
		img: 'd/d0/Prison-16.svg',
	},
	'amenity:place_of_worship': {
		name: 'Sted for tilbedelse',
		category: 'amenity',
		tag: 'place_of_worship',
		img: '0/04/Place-of-worship-16.svg',
	},
	'amenity:marketplace': {
		name: 'Markedsplass',
		category: 'amenity',
		tag: 'marketplace',
		img: '1/1c/Marketplace-14.svg',
	},
	'shop:convenience': {
		name: 'Nærbutikk',
		category: 'shop',
		tag: 'convenience',
		img: '9/96/Convenience-14.svg',
	},
	'shop:supermarket': {
		name: 'Dagligvarer',
		category: 'shop',
		tag: 'supermarket',
		img: '7/76/Supermarket-14.svg',
	},
	'shop:clothes': {
		name: 'Klesbutikk',
		category: 'shop',
		tag: 'clothes',
		img: 'd/de/Clothes-16.svg',
	},
	'shop:fashion': {
		name: 'Fashion',
		category: 'shop',
		tag: 'fashion',
		img: 'd/de/Clothes-16.svg',
	},
	'shop:hairdresser': {
		name: 'Hairdresser',
		category: 'shop',
		tag: 'hairdresser',
		img: '6/6b/Hairdresser-16.svg',
	},
	'shop:bakery': {
		name: 'Bakeri',
		category: 'shop',
		tag: 'bakery',
		img: 'f/fe/Bakery-16.svg',
	},
	'shop:car_repair': {
		name: 'Car Repair',
		category: 'shop',
		tag: 'car_repair',
		img: '2/26/Car_repair-14.svg',
	},
	'shop:doityourself': {
		name: 'Doityourself',
		category: 'shop',
		tag: 'doityourself',
		img: 'c/c3/Doityourself-16.svg',
	},
	'shop:hardware': {
		name: 'Hardware',
		category: 'shop',
		tag: 'hardware',
		img: 'c/c3/Doityourself-16.svg',
	},
	'shop:car': {
		name: 'Bilforhandler',
		category: 'shop',
		tag: 'car',
		img: 'b/b2/Purple-car.svg',
	},
	'shop:kiosk': {
		name: 'Kiosk',
		category: 'shop',
		tag: 'kiosk',
		img: 'b/bf/Newsagent-14.svg',
	},
	'shop:newsagent': {
		name: 'Newsagent',
		category: 'shop',
		tag: 'newsagent',
		img: 'b/bf/Newsagent-14.svg',
	},
	'shop:beauty': {
		name: 'Beauty',
		category: 'shop',
		tag: 'beauty',
		img: '0/06/Beauty-14.svg',
	},
	'amenity:car_wash': {
		name: 'Car Wash',
		category: 'amenity',
		tag: 'car_wash',
		img: '6/65/Car_wash-14.svg',
	},
	'shop:butcher': {
		name: 'Slakter',
		category: 'shop',
		tag: 'butcher',
		img: 'b/b8/Butcher.svg',
	},
	'shop:alcohol': {
		name: 'Alkoholservering',
		category: 'shop',
		tag: 'alcohol',
		img: 'e/eb/Alcohol-16.svg',
	},
	'shop:wine': {
		name: 'Wine',
		category: 'shop',
		tag: 'wine',
		img: 'e/eb/Alcohol-16.svg',
	},
	'shop:furniture': {
		name: 'Møbelbutikk',
		category: 'shop',
		tag: 'furniture',
		img: 'a/a0/Furniture-16.svg',
	},
	'shop:florist': {
		name: 'Blomsterhandler',
		category: 'shop',
		tag: 'florist',
		img: '6/69/Florist-16.svg',
	},
	'shop:mobile_phone': {
		name: 'Mobile Phone',
		category: 'shop',
		tag: 'mobile_phone',
		img: '1/19/Mobile-phone-16.svg',
	},
	'shop:electronics': {
		name: 'Elektronikk',
		category: 'shop',
		tag: 'electronics',
		img: '2/27/Electronics-16.svg',
	},
	'shop:shoes': {
		name: 'Skobutikk',
		category: 'shop',
		tag: 'shoes',
		img: '3/3b/Shoes-16.svg',
	},
	'shop:car_parts': {
		name: 'Bildeler',
		category: 'shop',
		tag: 'car_parts',
		img: '7/78/Car_parts-14.svg',
	},
	'shop:greengrocer': {
		name: 'Grønnsakshandler',
		category: 'shop',
		tag: 'greengrocer',
		img: 'd/d8/Greengrocer-14.svg',
	},
	'shop:farm': {
		name: 'Gårdsutsalg',
		category: 'shop',
		tag: 'farm',
		img: 'd/d8/Greengrocer-14.svg',
	},
	'shop:laundry': {
		name: 'Vaskeri',
		category: 'shop',
		tag: 'laundry',
		img: '3/34/Laundry-14.svg',
	},
	'shop:dry_cleaning': {
		name: 'Klesrens',
		category: 'shop',
		tag: 'dry_cleaning',
		img: '3/34/Laundry-14.svg',
	},
	'shop:optician': {
		name: 'Optiker',
		category: 'shop',
		tag: 'optician',
		img: '6/60/Optician-16.svg',
	},
	'shop:jewelry': {
		name: 'Gullsmed',
		category: 'shop',
		tag: 'jewelry',
		img: '8/8d/Jewellery-16.svg',
	},
	'shop:jewellery': {
		name: 'Gullsmed',
		category: 'shop',
		tag: 'jewellery',
		img: '8/8d/Jewellery-16.svg',
	},
	'shop:books': {
		name: 'Bokhandel',
		category: 'shop',
		tag: 'books',
		img: '1/18/Books-16.svg',
	},
	'shop:gift': {
		name: 'Gavebutikk',
		category: 'shop',
		tag: 'gift',
		img: '1/11/Gift-16.svg',
	},
	'shop:department_store': {
		name: 'Department Store',
		category: 'shop',
		tag: 'department_store',
		img: '7/79/Department_store-16.svg',
	},
	'shop:bicycle': {
		name: 'Bicycle',
		category: 'shop',
		tag: 'bicycle',
		img: '1/1b/Bicycle-16.svg',
	},
	'shop:confectionery': {
		name: 'Confectionery',
		category: 'shop',
		tag: 'confectionery',
		img: 'c/cc/Confectionery-14.svg',
	},
	'shop:chocolate': {
		name: 'Chocolate',
		category: 'shop',
		tag: 'chocolate',
		img: 'c/cc/Confectionery-14.svg',
	},
	'shop:pastry': {
		name: 'Pastry',
		category: 'shop',
		tag: 'pastry',
		img: 'c/cc/Confectionery-14.svg',
	},
	'shop:variety_store': {
		name: 'Variety Store',
		category: 'shop',
		tag: 'variety_store',
		img: '2/24/Variety_store-14.svg',
	},
	'shop:travel_agency': {
		name: 'Travel Agency',
		category: 'shop',
		tag: 'travel_agency',
		img: 'b/b1/Travel_agency-14.svg',
	},
	'shop:sports': {
		name: 'Sports',
		category: 'shop',
		tag: 'sports',
		img: 'd/df/Sports-14.svg',
	},
	'shop:chemist': {
		name: 'Chemist',
		category: 'shop',
		tag: 'chemist',
		img: '3/36/Chemist-14.svg',
	},
	'shop:computer': {
		name: 'Computer',
		category: 'shop',
		tag: 'computer',
		img: 'b/bb/Computer-14.svg',
	},
	'shop:stationery': {
		name: 'Stationery',
		category: 'shop',
		tag: 'stationery',
		img: '5/58/Stationery-14.svg',
	},
	'shop:pet': {
		name: 'Pet',
		category: 'shop',
		tag: 'pet',
		img: '5/5d/Pet-16.svg',
	},
	'shop:beverages': {
		name: 'Beverages',
		category: 'shop',
		tag: 'beverages',
		img: '9/98/Beverages-14.svg',
	},
	'shop:cosmetics': {
		name: 'Cosmetics',
		category: 'shop',
		tag: 'cosmetics',
		img: 'e/e9/Perfumery-14.svg',
	},
	'shop:perfumery': {
		name: 'Perfumery',
		category: 'shop',
		tag: 'perfumery',
		img: 'e/e9/Perfumery-14.svg',
	},
	'shop:tyres': {
		name: 'Tyres',
		category: 'shop',
		tag: 'tyres',
		img: '5/53/Tyres.svg',
	},
	'shop:motorcycle': {
		name: 'Motorcycle',
		category: 'shop',
		tag: 'motorcycle',
		img: '5/5d/Shop_motorcycle.svg',
	},
	'shop:garden_centre': {
		name: 'Hagesenter',
		category: 'shop',
		tag: 'garden_centre',
		img: '4/48/Garden_centre-14.svg',
	},
	'shop:copyshop': {
		name: 'Copyshop',
		category: 'shop',
		tag: 'copyshop',
		img: '2/2c/Copyshop-14.svg',
	},
	'shop:toys': {
		name: 'Toys',
		category: 'shop',
		tag: 'toys',
		img: '6/62/Toys-14.svg',
	},
	'shop:deli': {
		name: 'Deli',
		category: 'shop',
		tag: 'deli',
		img: '3/3b/Deli-14.svg',
	},
	'shop:tobacco': {
		name: 'Tobakk',
		category: 'shop',
		tag: 'tobacco',
		img: 'b/b0/Tobacco-14.svg',
	},
	'shop:seafood': {
		name: 'Seafood',
		category: 'shop',
		tag: 'seafood',
		img: 'd/d9/Seafood-14.svg',
	},
	'shop:interior_decoration': {
		name: 'Interior Decoration',
		category: 'shop',
		tag: 'interior_decoration',
		img: 'f/f4/Interior_decoration-14.svg',
	},
	'shop:ticket': {
		name: 'Ticket',
		category: 'shop',
		tag: 'ticket',
		img: '7/79/Ticket-14.svg',
	},
	'shop:photo': {
		name: 'Photo',
		category: 'shop',
		tag: 'photo',
		img: '4/4a/Photo-14.svg',
	},
	'shop:photo_studio': {
		name: 'Photo Studio',
		category: 'shop',
		tag: 'photo_studio',
		img: '4/4a/Photo-14.svg',
	},
	'shop:photography': {
		name: 'Photography',
		category: 'shop',
		tag: 'photography',
		img: '4/4a/Photo-14.svg',
	},
	'shop:trade': {
		name: 'Trade',
		category: 'shop',
		tag: 'trade',
		img: 'f/f2/Trade-14.svg',
	},
	'shop:wholesale': {
		name: 'Wholesale',
		category: 'shop',
		tag: 'wholesale',
		img: 'f/f2/Trade-14.svg',
	},
	'shop:outdoor': {
		name: 'Outdoor',
		category: 'shop',
		tag: 'outdoor',
		img: '7/76/Outdoor-14.svg',
	},
	'shop:houseware': {
		name: 'Houseware',
		category: 'shop',
		tag: 'houseware',
		img: '8/84/Houseware-14.svg',
	},
	'shop:art': {
		name: 'Art',
		category: 'shop',
		tag: 'art',
		img: 'f/fb/Art-14.svg',
	},
	'shop:paint': {
		name: 'Paint',
		category: 'shop',
		tag: 'paint',
		img: '3/31/Paint-14.svg',
	},
	'shop:fabric': {
		name: 'Fabric',
		category: 'shop',
		tag: 'fabric',
		img: '4/45/Fabric-14.svg',
	},
	'shop:bookmaker': {
		name: 'Bookmaker',
		category: 'shop',
		tag: 'bookmaker',
		img: '8/81/Bookmaker-14.svg',
	},
	'shop:second_hand': {
		name: 'Second Hand',
		category: 'shop',
		tag: 'second_hand',
		img: 'a/a3/Second_hand-14.svg',
	},
	'shop:charity': {
		name: 'Charity',
		category: 'shop',
		tag: 'charity',
		img: '8/85/Charity-14.svg',
	},
	'shop:bed': {
		name: 'Bed',
		category: 'shop',
		tag: 'bed',
		img: '9/91/Bed-14.svg',
	},
	'shop:medical_supply': {
		name: 'Medical Supply',
		category: 'shop',
		tag: 'medical_supply',
		img: 'f/fa/Medical_supply.svg',
	},
	'shop:hifi': {
		name: 'Hifi',
		category: 'shop',
		tag: 'hifi',
		img: '0/0c/Hifi-14.svg',
	},
	'shop:music': {
		name: 'Musikkbutikk',
		category: 'shop',
		tag: 'music',
		img: '1/13/Shop_music.svg',
	},
	'shop:coffee': {
		name: 'Kaffebar',
		category: 'shop',
		tag: 'coffee',
		img: 'd/d5/Coffee-14.svg',
	},
	'shop:musical_instrument': {
		name: 'Musikkinstrumentbutikk',
		category: 'shop',
		tag: 'musical_instrument',
		img: 'd/d0/Musical_instrument-14.svg',
	},
	'shop:tea': {
		name: 'Tea',
		category: 'shop',
		tag: 'tea',
		img: '3/34/Tea-14.svg',
	},
	'shop:video': {
		name: 'Video',
		category: 'shop',
		tag: 'video',
		img: '2/2d/Video-14.svg',
	},
	'shop:bag': {
		name: 'Veskebutikk',
		category: 'shop',
		tag: 'bag',
		img: '4/41/Bag-14.svg',
	},
	'shop:carpet': {
		name: 'Teppebutikk',
		category: 'shop',
		tag: 'carpet',
		img: '5/5f/Carpet-14.svg',
	},
	'shop:video_games': {
		name: 'Video Games',
		category: 'shop',
		tag: 'video_games',
		img: 'a/ab/Video_games-14.svg',
	},
	'amenity:vehicle_inspection': {
		name: 'Vehicle Inspection',
		category: 'amenity',
		tag: 'vehicle_inspection',
		img: '5/56/Vehicle_inspection-14.svg',
	},
	'shop:dairy': {
		name: 'Meieributikk',
		category: 'shop',
		tag: 'dairy',
		img: '0/0e/Dairy.svg',
	},
	shop: {
		name: 'Butikk',
		category: 'shop',
		tag: '*',
		img: 'c/c4/Shop-other-16.svg',
	},
	'amenity:driving_school': {
		name: 'Kjøreskole',
		category: 'amenity',
		tag: 'driving_school',
		img: 'c/c4/Shop-other-16.svg',
	},
	'office:*': {
		name: '*',
		category: 'office',
		tag: '*',
		img: '9/92/Office-16.svg',
	},
	'amenity:nursing_home': {
		name: 'Nursing Home',
		category: 'amenity',
		tag: 'nursing_home',
		img: 'a/ad/Social_amenity_darken_80-16.svg',
	},
	'amenity:childcare': {
		name: 'Childcare',
		category: 'amenity',
		tag: 'childcare',
		img: 'a/ad/Social_amenity_darken_80-16.svg',
	},
	'man_made:storage_tank': {
		name: 'Storage Tank',
		category: 'man_made',
		tag: 'storage_tank',
		img: '1/15/Storage_tank-14.svg',
	},
	'man_made:silo': {
		name: 'Silo',
		category: 'man_made',
		tag: 'silo',
		img: '1/15/Storage_tank-14.svg',
	},
	'man_made:tower': {
		name: 'Tower',
		category: 'man_made',
		tag: 'tower',
		img: 'c/c0/Tower_dome.svg',
	},
	'power:generator': {
		name: 'Generator',
		category: 'power',
		tag: 'generator',
		img: 'b/b2/Generator_wind-14.svg',
	},
	'amenity:hunting_stand': {
		name: 'Hunting Stand',
		category: 'amenity',
		tag: 'hunting_stand',
		img: 'a/a6/Hunting-stand-16.svg',
	},
	'historic:wayside_cross': {
		name: 'Wayside Cross',
		category: 'historic',
		tag: 'wayside_cross',
		img: '2/26/Christian.9.svg',
	},
	'man_made:cross': {
		name: 'Kors',
		category: 'man_made',
		tag: 'cross',
		img: '2/26/Christian.9.svg',
	},
	'man_made:water_tower': {
		name: 'Vanntårn',
		category: 'man_made',
		tag: 'water_tower',
		img: '1/13/Water-tower-16.svg',
	},
	'man_made:mast': {
		name: 'Mast',
		category: 'man_made',
		tag: 'mast',
		img: '2/25/Mast_communications.svg',
	},
	'military:bunker': {
		name: 'Bunker',
		category: 'military',
		tag: 'bunker',
		img: '3/36/Bunker-osmcarto.svg',
	},
	'man_made:chimney': {
		name: 'Chimney',
		category: 'man_made',
		tag: 'chimney',
		img: '8/8a/Chimney-14.svg',
	},
	'man_made:lighthouse': {
		name: 'Fyrtårn',
		category: 'man_made',
		tag: 'lighthouse',
		img: 'c/c2/Lighthouse-16.svg',
	},
	'advertising:column': {
		name: 'Column',
		category: 'advertising',
		tag: 'column',
		img: '2/20/Column-14.svg',
	},
	'man_made:crane': {
		name: 'Kran',
		category: 'man_made',
		tag: 'crane',
		img: 'e/e0/Crane-14.svg',
	},
	'man_made:windmill': {
		name: 'Vindmølle',
		category: 'man_made',
		tag: 'windmill',
		img: '0/0b/Windmill-16.svg',
	},
	'man_made:communications_tower': {
		name: 'Communications Tower',
		category: 'man_made',
		tag: 'communications_tower',
		img: '0/0c/Communication_tower-14.svg',
	},
	'man_made:telescope': {
		name: 'Telescope',
		category: 'man_made',
		tag: 'telescope',
		img: 'e/e0/Telescope_dome-14.svg',
	},
	'power:tower': {
		name: 'Tower',
		category: 'power',
		tag: 'tower',
		img: 'e/e3/Power_tower.svg',
	},
	'power:pole': {
		name: 'Pole',
		category: 'power',
		tag: 'pole',
		img: 'd/d8/Power_pole.svg',
	},
	'place:city': {
		name: 'City',
		category: 'place',
		tag: 'city',
		img: '9/97/Place-6.svg',
	},
	'capital:*': {
		name: '*',
		category: 'capital',
		tag: '*',
		img: '0/0d/Place-capital-8.svg',
	},
	'entrance:yes': {
		name: 'Yes',
		category: 'entrance',
		tag: 'yes',
		img: '9/92/Rect.svg',
	},
	'entrance:main': {
		name: 'Main',
		category: 'entrance',
		tag: 'main',
		img: '0/00/Entrance_main.svg',
	},
	'entrance:service': {
		name: 'Service',
		category: 'entrance',
		tag: 'service',
		img: '2/27/Entrance.svg',
	},
	'entrance:*': {
		name: '*',
		category: 'entrance',
		tag: '*',
		img: '0/0d/Rectdiag.svg',
	},
}
